import { useState } from "react";
import { Loader2, Mail, Copy } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export default function NewsletterSignup({ prefix = "newsletter" }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [code, setCode] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, origin_url: window.location.origin });
      setCode(data.code);
      localStorage.setItem("albion_welcome_email", email);
      toast.success(data.already ? "You're already on the list — here's your code" : "Welcome! We've emailed your code too");
    } catch (e2) { toast.error(errMsg(e2)); }
    setBusy(false);
  };

  const copy = () => { navigator.clipboard?.writeText(code); toast.success("Code copied"); };

  if (code)
    return (
      <div className="rounded-2xl border border-[#D4AF37]/40 bg-white/5 p-5" data-testid={`${prefix}-success`}>
        <p className="text-white font-serif text-xl">You're in. Here's 10% off your first order:</p>
        <button type="button" onClick={copy} className="mt-3 inline-flex items-center gap-3 rounded-xl border-2 border-dashed border-[#D4AF37] px-5 py-2 font-mono text-2xl font-bold tracking-[0.2em] text-[#D4AF37] hover:bg-white/5 transition-colors" data-testid={`${prefix}-code`}>
          {code} <Copy className="w-4 h-4" />
        </button>
        <p className="mt-2 text-xs text-slate-400">Enter it at checkout with the same email. First orders only.</p>
      </div>
    );

  return (
    <form onSubmit={submit} className="rounded-2xl border border-white/10 bg-white/5 p-5" data-testid={`${prefix}-form`}>
      <p className="font-mono text-xs uppercase tracking-widest text-[#D4AF37]">The Pantry Letter</p>
      <p className="mt-2 text-white font-serif text-xl">New hampers &amp; seasonal shops first — plus 10% off your first order.</p>
      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <div className="relative flex-1">
          <Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address" className="w-full rounded-full bg-white text-slate-900 pl-10 pr-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#D4AF37]" data-testid={`${prefix}-email-input`} />
        </div>
        <button disabled={busy} className="rounded-full bg-[#D4AF37] text-[#0F172A] font-semibold px-6 py-3 text-sm hover:bg-[#e2c25a] disabled:opacity-60 transition-colors flex items-center justify-center gap-2" data-testid={`${prefix}-submit-button`}>
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Join &amp; get 10% off
        </button>
      </div>
      <p className="mt-2 text-[11px] text-slate-500">Unsubscribe any time with one click.</p>
    </form>
  );
}
